const configBoardTemplate = {
    homeNews:{
        listLayout:'BoardListHomeNewsLayout',
    },
    homeDonate:{
        listLayout:'BoardListHomeDonateLayout',
    },
    news:{
        listLayout:'BoardListNewsLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    donate:{
        listLayout:'BoardListDonateLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    business:{
        listLayout:'BoardListBusinessLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    album:{
        listLayout:'BoardListAlbumLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    financial:{
        listLayout:'BoardListFinancialLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    newsDetail:{
        detailLayout: 'BoardDetailNewsLayout',
    },
    businessDetail:{
        detailLayout: 'BoardDetailBusinessLayout',
    },
    financialDetail:{
        detailLayout: 'BoardDetailFinancialLayout',
    },
    donatePrimeDetail:{
        detailLayout: 'BoardDetailDonateLayout',
    },
    donateDetail:{
        detailLayout: 'BoardDetailDonateLayout',
    },
    albumDetail:{
        detailLayout: 'BoardDetailAlbumLayout',
    },
    primeDonate:{
        listLayout:'BoardListPrimeLayout',
    },

    newsSearch:{
        listLayout:'BoardListSearchLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    donateSearch:{
        listLayout:'BoardListSearchLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    businessSearch:{
        listLayout:'BoardListSearchLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    albumSearch:{
        listLayout:'BoardListSearchLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
    financialSearch:{
        listLayout:'BoardListSearchLayout',
        emptyLayout:'BoardEmptyDefaultLayout',
        paginationLayout:'PaginationDefaultLayout',
    },
}
export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    }
}
